<template>
  <RevDrawer
    :name="MODAL_NAMES.CARRIERS_COMPATIBILITY"
    :title="i18n(modalTitle)"
  >
    <template #body>
      <div class="pb-32">
        <h2 class="heading-1 mb-16">
          {{ i18n(primaryTitle) }}
        </h2>

        <ContentUnlocked v-if="isUnlocked" />
        <ContentLocked v-if="isLocked" />

        <ContentInfo />

        <h2 class="heading-2 mb-8">
          {{ i18n(secondaryTitle) }}
        </h2>

        <ContentUnlocked v-if="isLocked" />
        <ContentLocked v-if="isUnlocked" />
      </div>
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAMES } from '~/scopes/product/constants'

import translations from './CarriersCompatibilityModal.translations'
import ContentInfo from './ContentInfo.vue'
import ContentLocked from './ContentLocked.vue'
import ContentUnlocked from './ContentUnlocked.vue'

const props = defineProps<{
  type: 'locked' | 'unlocked'
}>()

const i18n = useI18n()

const isLocked = computed(() => {
  return props.type === 'locked'
})

const isUnlocked = computed(() => {
  return props.type === 'unlocked'
})

const modalTitle = computed(() => {
  return isUnlocked.value
    ? translations.titleUnlocked
    : translations.titleLocked
})

const primaryTitle = computed(() => {
  return isUnlocked.value
    ? translations.titleUnlockedFull
    : translations.titleLockedFull
})

const secondaryTitle = computed(() => {
  return isUnlocked.value
    ? translations.titleLocked
    : translations.titleUnlocked
})
</script>
